"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CtaSection_1 = __importDefault(require("../../components/posa/CtaSection"));
const PosaCardSuccessViewStyled_1 = __importDefault(require("./PosaCardSuccessViewStyled"));
const PosaMessageContext_1 = require("../../context/PosaMessageContext");
const PosaRedeemStore_1 = __importDefault(require("../../stores/PosaRedeemStore"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_1 = __importDefault(require("react"));
const StepsSlider_1 = __importDefault(require("../../components/posa/StepsSlider"));
const SuccessHeader_1 = __importDefault(require("../../components/posa/SuccessHeader"));
// import queryString from 'query-string';
const epic_alt_utils_1 = require("epic-alt-utils");
const utils_1 = require("../../utils");
/**
 * POSA Card Redeem View.
 */
let PosaCardSuccessView = class PosaCardSuccessView extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.getCtaSection = () => {
            const { ctaAction, posaRedeemStore } = this.props;
            const { sections: { sections } } = posaRedeemStore.page;
            let ctaData = null;
            sections.forEach(section => {
                for (const prop in section) {
                    if (section.hasOwnProperty(prop)) {
                        const data = section[prop];
                        if (typeof data === 'object') {
                            const { _type } = data;
                            if (_type === 'POSA CTA Section') {
                                ctaData = react_1.default.createElement(CtaSection_1.default, { data: data, key: _type, ctaAction: ctaAction });
                            }
                        }
                    }
                }
            });
            return ctaData;
        };
        this.getSuccess = () => {
            const { resetFlow, trackEvent, showBonusSection } = this.props;
            return (react_1.default.createElement(SuccessHeader_1.default, { posaRedeemStore: this.props.posaRedeemStore, resetFlow: resetFlow, trackEvent: trackEvent, showBonusSection: showBonusSection }));
        };
        this.getStepsSlider = () => {
            const successData = utils_1.getSuccessData(this.props.posaRedeemStore);
            return react_1.default.createElement(StepsSlider_1.default, { data: successData.sliderSection });
        };
    }
    static getStores() {
        return [PosaRedeemStore_1.default];
    }
    static getPropsFromStores() {
        return {
            posaRedeemStore: PosaRedeemStore_1.default.getState()
        };
    }
    render() {
        const { redeemed, platform, page: { configs: { id }, messages } } = this.props.posaRedeemStore;
        if (!redeemed)
            return null;
        return (react_1.default.createElement(PosaMessageContext_1.PosaMessageProvider, { value: JSON.parse(messages) },
            react_1.default.createElement(PosaCardSuccessViewStyled_1.default, { className: `epic-code-redemption posaSuccessView ${platform}`, id: id },
                this.getSuccess(),
                this.getStepsSlider(),
                this.getCtaSection())));
    }
};
PosaCardSuccessView.propTypes = {
    posaRedeemStore: prop_types_1.default.object,
    ctaAction: prop_types_1.default.func,
    resetFlow: prop_types_1.default.func,
    trackEvent: prop_types_1.default.func,
    showBonusSection: prop_types_1.default.bool
};
PosaCardSuccessView = __decorate([
    epic_alt_utils_1.connectToStores
], PosaCardSuccessView);
exports.default = PosaCardSuccessView;
//# sourceMappingURL=PosaCardSuccessView.js.map